import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useLang } from "../../context/LanguageContext";
import useVisitorTracking from "../../hooks/useVisitorTracking";

export default function Layout() {
  const { loading } = useLang();
  useVisitorTracking();
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1 pt-28">
        {loading ? (
          <div className="min-h-[60vh] flex items-center justify-center">
            <div className="font-display text-3xl text-primary/40 animate-pulse">GYBC</div>
          </div>
        ) : (
          <Outlet />
        )}
      </main>
      <Footer />
    </div>
  );
}
